/**
 * iurop-collection.js — interacción de la PLP (Glucody).
 * - "Leer más" de la descripción SEO.
 * - Píldora "Filtrar y Ordenar": pliega/despliega el panel [data-plp-filters].
 * - Filtros: cualquier cambio re-envía el formulario (GET) conservando sort.
 * - Precio: doble slider → actualiza etiqueta y campos ocultos gte/lte.
 * - Filtros de TEMA (Sabor/Color): grupos construidos desde los data-f-* de
 *   las celdas (metacampos custom.sabor/custom.color), filtrado en CLIENTE
 *   sin recargar y sin depender de Search & Discovery. La selección se
 *   persiste en sessionStorage para sobrevivir a los reloads de los filtros
 *   nativos (precio/orden) y al "Ver resultados" del sheet móvil.
 */
(function () {
  'use strict';

  function initPlp(root) {
    if (root.dataset.plpInit) return; // el swap de colecciones re-lanza initAll
    root.dataset.plpInit = '1';
    var form = root.querySelector('[data-plp-form]');

    // Leer más
    var toggle = root.querySelector('[data-plp-desc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var desc = root.querySelector('[data-plp-desc]');
        var open = desc.classList.toggle('is-open');
        toggle.textContent = open ? toggle.getAttribute('data-less') : toggle.getAttribute('data-more');
      });
    }

    function isSheet() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    // Toggle de panel.
    // Móvil/tablet: bottom-sheet controlado por 'is-sheet-open' (arranca
    // cerrado desde CSS, sin flash). Escritorio: barra lateral abierta por
    // defecto, la píldora la oculta con 'filters-closed'.
    var pill = root.querySelector('[data-plp-filters-toggle]');
    if (pill) {
      pill.setAttribute('aria-expanded', isSheet() ? 'false' : 'true');
      pill.addEventListener('click', function () {
        if (isSheet()) {
          var open = root.classList.toggle('is-sheet-open');
          pill.setAttribute('aria-expanded', open ? 'true' : 'false');
          document.documentElement.classList.toggle('plp-sheet-open', open);
        } else {
          var closed = root.classList.toggle('filters-closed');
          pill.setAttribute('aria-expanded', closed ? 'false' : 'true');
        }
      });
    }

    // Cerrar el sheet (backdrop, ✕)
    root.querySelectorAll('[data-plp-filters-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.classList.remove('is-sheet-open');
        if (pill) pill.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('plp-sheet-open');
      });
    });

    if (!form) return;

    function clean() {
      // limpia parámetros vacíos para URLs limpias
      form.querySelectorAll('input[type="hidden"]').forEach(function (h) {
        if (h.value === '') h.disabled = true;
      });
    }

    function submit() {
      clean();
      form.submit();
    }

    // El botón "Ver resultados" (submit nativo) también limpia parámetros
    form.addEventListener('submit', clean);

    // Escritorio: cada cambio re-envía al instante. Móvil (sheet): se van
    // acumulando selecciones y se aplican todas con "Ver resultados" (submit
    // nativo del <form>), para no recargar y cerrar el sheet en cada toque.
    form.addEventListener('change', function (e) {
      if (isSheet()) return;
      if (e.target.matches('input[type="checkbox"], input[type="radio"]')) submit();
    });

    // Filtros de tema (Sabor/Color) desde metacampos, en cliente
    initCustomFilters(root, form);

    // Precio: doble slider
    var price = form.querySelector('[data-plp-price]');
    if (price) {
      var minR = price.querySelector('[data-plp-price-min]');
      var maxR = price.querySelector('[data-plp-price-max]');
      var out = price.querySelector('[data-plp-price-out]');
      var gte = price.querySelector('[data-plp-price-gte]');
      var lte = price.querySelector('[data-plp-price-lte]');
      var fill = price.querySelector('[data-plp-price-fill]');
      var maxV = parseFloat(price.getAttribute('data-max')) || 100;

      // QA v2 (orden Nicolas 15-jul): arrastre CONTINUO por céntimos con
      // decimales en vivo; al SOLTAR, redondeo al número natural y los
      // pulgares se anclan al entero (lo aplicado == lo mostrado; el
      // re-pintado del Liquid tras recargar también es entero).
      function fmtDrag(n) {
        return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
      }

      function paint() {
        var lo = Math.min(+minR.value, +maxR.value);
        var hi = Math.max(+minR.value, +maxR.value);
        if (out) out.textContent = fmtDrag(lo) + ' - ' + fmtDrag(hi) + '€';
        // Relleno azul entre ambos pulgares
        if (fill && maxV > 0) {
          fill.style.left = (lo / maxV) * 100 + '%';
          fill.style.right = (100 - (hi / maxV) * 100) + '%';
        }
      }

      [minR, maxR].forEach(function (r) {
        r.addEventListener('input', paint);
        r.addEventListener('change', function () {
          // al soltar: redondeo al natural y ancla cada pulgar a su entero
          minR.value = Math.round(+minR.value);
          maxR.value = Math.round(+maxR.value);
          var lo = Math.min(+minR.value, +maxR.value);
          var hi = Math.max(+minR.value, +maxR.value);
          if (out) out.textContent = lo + ' - ' + hi + '€';
          if (fill && maxV > 0) {
            fill.style.left = (lo / maxV) * 100 + '%';
            fill.style.right = (100 - (hi / maxV) * 100) + '%';
          }
          if (gte) gte.value = lo > 0 ? String(lo) : '';
          if (lte) lte.value = hi < maxV ? String(hi) : '';
          // Móvil (sheet): no recarga; se aplica con "Ver resultados"
          if (!isSheet()) submit();
        });
      });
      paint();
    }
  }

  function initCustomFilters(root, form) {
    var holder = form.querySelector('[data-plp-cf]');
    var groupTpl = form.querySelector('[data-plp-cf-tpl]');
    var checkTpl = form.querySelector('[data-plp-cf-check-tpl]');
    if (!holder || !groupTpl || !checkTpl) return;

    var defs;
    try {
      defs = JSON.parse(holder.getAttribute('data-cf-defs')) || [];
    } catch (e) {
      return;
    }
    var cells = Array.prototype.slice.call(root.querySelectorAll('.glucody-plp__cell'));
    var empty = root.querySelector('[data-plp-cf-empty]');
    var storeKey = 'plpcf:' + location.pathname;

    var state = {};
    try {
      state = JSON.parse(sessionStorage.getItem(storeKey)) || {};
    } catch (e) { /* sin persistencia */ }

    function attrOf(cell, attr) {
      return cell.getAttribute('data-f-' + attr) || '';
    }

    function apply() {
      var visible = 0;
      cells.forEach(function (cell) {
        var ok = defs.every(function (def) {
          var sel = state[def.attr];
          if (!sel || !sel.length) return true;
          return sel.indexOf(attrOf(cell, def.attr)) !== -1;
        });
        cell.hidden = !ok;
        if (ok) visible++;
      });
      if (empty) empty.hidden = visible > 0;
      try {
        sessionStorage.setItem(storeKey, JSON.stringify(state));
      } catch (e) { /* sin persistencia */ }
    }

    var built = 0;
    defs.forEach(function (def) {
      // valores distintos con recuento sobre TODA la colección (una página)
      var counts = {};
      cells.forEach(function (cell) {
        var v = attrOf(cell, def.attr);
        if (v) counts[v] = (counts[v] || 0) + 1;
      });
      var values = Object.keys(counts).sort(function (a, b) {
        return a.localeCompare(b, 'es');
      });
      if (values.length < 2) return; // grupo sin variedad no aporta

      var group = groupTpl.content.firstElementChild.cloneNode(true);
      group.querySelector('[data-cf-title]').textContent = def.label;
      var list = group.querySelector('ul');
      var selected = state[def.attr] || [];

      values.forEach(function (v) {
        var li = checkTpl.content.firstElementChild.cloneNode(true);
        var input = li.querySelector('input');
        input.setAttribute('data-cf-attr', def.attr);
        input.value = v;
        input.checked = selected.indexOf(v) !== -1;
        li.querySelector('span').textContent = v;
        // filtrado en cliente: no recargar (parar antes del listener del form)
        input.addEventListener('change', function (e) {
          e.stopPropagation();
          var sel = state[def.attr] || [];
          if (input.checked) sel.push(v);
          else sel = sel.filter(function (x) { return x !== v; });
          state[def.attr] = sel;
          apply();
        });
        list.appendChild(li);
      });

      holder.parentNode.insertBefore(group, holder);
      built++;
    });

    // "Limpiar" también resetea la selección de tema
    var clear = form.querySelector('[data-plp-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        try { sessionStorage.removeItem(storeKey); } catch (e) { /* nada */ }
      });
    }

    if (built) apply();
  }

  function initAll() {
    document.querySelectorAll('[data-plp]').forEach(initPlp);
  }

  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  /* ------------------------------------------------------------------ */
  /* Cambio entre colecciones SIN recarga (QA: "la transición no está    */
  /* optimizada"): los círculos de categoría hacen prefetch al apuntar   */
  /* y al hacer clic se reemplazan solo las secciones de <main> que      */
  /* cambian + pushState — mismo patrón que el selector de familia PDP.  */
  /* Los JS por sección se re-enganchan con shopify:section:load.        */
  /* ------------------------------------------------------------------ */
  var catCache = {};

  function catFetch(url) {
    if (!catCache[url]) {
      catCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).catch(function (err) {
        delete catCache[url];
        throw err;
      });
    }
    return catCache[url];
  }

  function catSwap(url, push) {
    return catFetch(url).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var changed = false;
      document.querySelectorAll('main .shopify-section').forEach(function (sec) {
        var fresh = doc.getElementById(sec.id);
        if (fresh && fresh.innerHTML !== sec.innerHTML) {
          sec.replaceWith(fresh);
          changed = true;
        }
      });
      document.querySelectorAll('.glucody-plp.is-loading').forEach(function (el) {
        el.classList.remove('is-loading');
      });
      if (!changed) return;
      document.title = doc.title;
      if (push) {
        if (!history.state || !history.state.plpCat) {
          history.replaceState({ plpCat: true }, '', window.location.href);
        }
        history.pushState({ plpCat: true }, '', url);
      }
      // que el cambio se vea desde arriba de la parrilla
      var plp = document.querySelector('.glucody-plp');
      if (plp) {
        var top = plp.getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'instant' });
      }
      document.dispatchEvent(new Event('shopify:section:load'));
    });
  }

  function catLink(target) {
    return target.closest ? target.closest('.glucody-plp__cat-link') : null;
  }

  document.addEventListener('pointerover', function (e) {
    var a = catLink(e.target);
    if (a) catFetch(a.href);
  });
  document.addEventListener('touchstart', function (e) {
    var a = catLink(e.target);
    if (a) catFetch(a.href);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var a = catLink(e.target);
    if (!a) return;
    // respetar abrir-en-pestaña-nueva (Cmd/Ctrl/Shift/clic central)
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    var item = a.closest('.glucody-plp__cat');
    if (item && item.classList.contains('is-active')) return;
    var plp = document.querySelector('.glucody-plp');
    if (plp) plp.classList.add('is-loading');
    catSwap(a.href, true).catch(function () {
      window.location.href = a.href; // fallback: navegación normal
    });
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.plpCat) {
      catSwap(window.location.href, false).catch(function () {
        window.location.reload();
      });
    }
  });
})();
